/* eslint-disable */
import React, { useContext, useState, useEffect } from 'react'
import Box from '@material-ui/core/Box'
import Container from '@material-ui/core/Container'
import { Link, useHistory } from 'react-router-dom'
import {
    currencyFormat,
    dateFormatFront,
    handleRedirectInternal,
} from '../../../Product/common/components'
import { Redirect } from 'react-router-dom'
import ProductContext from '../../../Product/context/product/productContext'
import AuthContext from '../../../Product/context/auth/authContext'
import { Pagination } from '@material-ui/lab'
import Timer from '../../../Product/common/timer'
import { Button, Tooltip } from '@material-ui/core'
import MultisellerSlider from '../../../Component/SlidePanel/MultisellerSlider'
import NoRecordsFound from '../../../Product/components/atoms/NoRecordsFound'
import CustomDialog from '../../../Product/components/organisms/Dialog'
import { getImageurl, imageError } from '../../../utils/commonFunctions'
import Loader from '../../../assets/loader'
import PrimaryButton from '../../../Product/components/atoms/PrimaryButton'
import SecondaryButton from '../../../Product/components/atoms/SecondaryButton'
import userContext from '../../../Product/context/user/userContext'

const Invoice = (props) => {
    const productContext = useContext(ProductContext)
    const {
        seller_allproducts,
        getAllSellerProducts,
        get_seller_dashboard,
        seller_dashboard_data,
    } = productContext

    const authContext = useContext(AuthContext)
    const { isAuthenticated, isAdmin, user } = authContext
    const [selectedProduct, setSelectedProduct] = useState(null)
    const [data, setData] = useState([])
    const [userData, setUserData] = useState({})
    const [sellerData, setSellerData] = useState({})
    const [loading, setLoading] = useState(true)
    const history = useHistory()
    const [toInvoice, settoInvoice] = useState(false)
    const [buyerName, setBuyerName] = useState('')
    const [toInvoiceID, settoInvoiceID] = useState({
        inv_id: 0,
        user_id: 0,
    })
    const [popupchecked, setPopupchecked] = useState(false)
    const [termscondtions, setTermscondition] = useState('')
    const [search, setSearch] = useState({
        status: 'sold,open',
        limit: 12,
        page: 1,
        paid: props.page === 'paid' ? 1 : 0,
    })
    const {
        static_page,
        getStaticPage,
        responseStatus: responseStatusUser,
    } = useContext(userContext)
    useEffect(() => {
        setLoading(false)
    }, [seller_allproducts])
    const onHandlePage = (event, value) => {
        setSearch({ ...search, page: value })
    }
    const categoryTypes = {}
    global.allCategories.map((catgeory) => (categoryTypes[catgeory.id] = catgeory))
    const handleClose = () => setSelectedProduct(null)

    const handleClick = async (id) => {
        setSelectedProduct(id)
    }
    useEffect(() => {
        if (global?.storeConfigration?.checkout_terms_and_condtions?.value == 1) {
            getStaticPage(
                {
                    page_id: 'checkout_terms_and_condtions',
                },
                1,
            )
        }
    }, [])
    useEffect(() => {
        if (global?.storeConfigration?.checkout_terms_and_condtions?.value == 1) {
            if (static_page.content) {
                setTermscondition(static_page.content)
            }
        }
    }, [static_page])

    useEffect(() => {
        if (isAuthenticated) {
            setLoading(true)
            if (props.page === 'paid') {
                setLoading(true)
                getAllSellerProducts(search)
            } else if (props.page === 'unpaid') {
                setLoading(true)
                getAllSellerProducts(search)
            }
        }
    }, [search, isAuthenticated])
    useEffect(() => {
        setPopupchecked(buyerName ? true : false)
    }, [buyerName])
    return (
        <div>
            {toInvoice ? (
                <Redirect to={`invoice/${toInvoiceID.inv_id}/${toInvoiceID.user_id}`} />
            ) : null}
            {loading ? (
                <div className="text-center">
                    <Loader />
                </div>
            ) : seller_allproducts.result.length ? (
                <>
                    <div className="table-responsive">
                        <table className="table table-hover">
                            <thead>
                                <tr>
                                    <th className="numCell">S.No.</th>
                                    <th className="numCell">Invoice Id</th>
                                    <th className="numCell">Lot Id</th>
                                    <th>Image</th>
                                    <th>Product Name</th>
                                    <th>Amount</th>
                                    {props.page === 'paid' &&
                                    global.storeConfigration.unique_slot4.value != 1 ? (
                                        <Tooltip
                                            // open={true}
                                            title={
                                                'The Payout Is Typically Paid Out 3-7 Business Days After A Successful Payment Is Received!'
                                            }
                                            arrow={true}
                                            placement="top"
                                            // disableHoverListener={true}
                                            // disableFocusListener={true}
                                        >
                                            <th>Payout</th>
                                        </Tooltip>
                                    ) : null}
                                    {/* <th>Type</th> */}
                                    <th>Action</th>
                                </tr>
                            </thead>
                            {seller_allproducts.result.map((item, index) => {
                                return (
                                    <>
                                        <tbody>
                                            <tr>
                                                <td>{index + 1}</td>
                                                <td>{item.common_invoice}</td>
                                                <td>{item.id}</td>
                                                <td>
                                                    <img
                                                        className="pro-img"
                                                        src={getImageurl(
                                                            item.store_id.toString(),
                                                            item.avatar,
                                                        )}
                                                        alt={item.title}
                                                        width="65"
                                                        height="65"
                                                        onError={(e) =>
                                                            (e.target.src = imageError())
                                                        }
                                                    />
                                                </td>
                                                <td>{global.storeDetails?.theme == 1
                                                                    ? item?.category_id ==
                                                                      global?.storeConfigration
                                                                          ?.similar_category?.value
                                                                        ? item?.title
                                                                        : `${
                                                                              item?.custom_field_5 !=
                                                                              0
                                                                                  ? item?.custom_field_5
                                                                                  : ''
                                                                          } ${item?.subcategory
                                                                              ?.split(',')
                                                                              ?.map(
                                                                                  (val) =>
                                                                                      categoryTypes[
                                                                                          val
                                                                                      ]
                                                                                          ?.description ??
                                                                                      '',
                                                                              )
                                                                              ?.join(', ')}` : item.title}</td>
                                                <td style={{ whiteSpace: 'nowrap' }}>
                                                    <b>
                                                        {currencyFormat(
                                                            parseFloat(
                                                                item.buynowpaid
                                                                    ? item.buynowamount
                                                                    : item.total_invoice,
                                                            ),
                                                        )}
                                                    </b>
                                                </td>
                                                {props.page === 'paid' &&
                                                global.storeConfigration.unique_slot4.value != 1 ? (
                                                    <td style={{ whiteSpace: 'nowrap' }}>
                                                        <b>
                                                            {currencyFormat(
                                                                parseFloat(
                                                                    item.additional_amount_3,
                                                                ),
                                                            )}
                                                        </b>
                                                    </td>
                                                ) : null}
                                                {/* <td>{item.isbuynow ? 'Buy Now' : 'Auction'}</td> */}
                                                <td className="invoiceActions">
                                                    <PrimaryButton
                                                        btnSize="minMaxContent"
                                                        onClick={() =>
                                                            handleRedirectInternal(
                                                                history,
                                                                item.auction
                                                                    ? `invoice/auction?id=${item.common_invoice}&bid=${item.buynowuser_id}`
                                                                    : `invoice/buynow?id=${item.common_invoice}&bid=${item.buynowuser_id}`,
                                                            )
                                                        }
                                                    >
                                                        View Invoice
                                                    </PrimaryButton>
                                                    {global?.storeConfigration
                                                        ?.checkout_terms_and_condtions?.value ==
                                                    1 ? (
                                                        <SecondaryButton
                                                            btnSize="minMaxContent"
                                                            onClick={() => {
                                                                setBuyerName(
                                                                    `${item.buyer_first_name} ${item.buyer_last_name}`,
                                                                )
                                                            }}
                                                        >
                                                            Terms & Conditions
                                                        </SecondaryButton>
                                                    ) : null}
                                                </td>
                                            </tr>
                                        </tbody>
                                    </>
                                )
                            })}
                        </table>
                    </div>
                    <div className="d-flex mt-3">
                        <div className="ml-auto mt-2">
                            {'Showing'} {search.limit * (search.page - 1) + 1} -{' '}
                            {search.limit * search.page > seller_allproducts.length
                                ? seller_allproducts.length
                                : search.limit * search.page}{' '}
                            of {seller_allproducts.length}
                        </div>
                        <Pagination
                            count={Math.ceil(seller_allproducts.length / search.limit)}
                            page={search.page}
                            onChange={onHandlePage}
                        />
                    </div>
                    <MultisellerSlider
                        selectedLot={selectedProduct}
                        handleClose={handleClose}
                        type={props.type ? props.type : ''}
                    />
                </>
            ) : (
                <>
                    <NoRecordsFound />
                </>
            )}
            <CustomDialog
                open={popupchecked}
                function={() => {
                    setBuyerName('')
                }}
                size="md"
                className="save-search-modal"
                title="Terms and Conditions"
                closeBtn={true}
            >
                <div
                    dangerouslySetInnerHTML={{
                        __html: `${global?.storeDetails?.terms_condition}${termscondtions}<p><b>Terms and conditions accepted by the ${buyerName}.</b</p>`,
                    }}
                ></div>
            </CustomDialog>
        </div>
    )
}

export default Invoice
